module.exports = {"welcome":"Bienvenido","data_ver":"Data","app_ver":"App","server":"Servidor","password":"Clave","language":"Idioma","display":"Monitor","maintain":"mantenimiento","inquire":"Consulta","code":"Codigo","price":"Precio","success":"Éxito","error":"Error","warn":"Avisar","login_error":"No puedes iniciar sesión","last_login":"último inicio de sesión"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/es.json
// module id = 7ucu
// module chunks = 1